import dateUtil from "@/utils/date.js"

export const popinMultiPayProps = () => ({
  echeancier: {
    type: Object,
    required: false,
    default: null
  },
  error: {
    type: Object,
    required: false
  },
  hasQuatreFois: {
    type: Boolean,
    required: false,
    default: true
  },
  hasTroisFois: {
    type: Boolean,
    required: false,
    default: true
  },
  min: {
    type: Number,
    required: false,
    default: 200
  },
  max: {
    type: Number,
    required: false,
    default: 3000
  }
})

export const popinMultiPayEmits = () => ([
  "updateEchancier"
])

export const usePopinMultiPay = (props, context, popinRef) => {
  const currentCode = ref(null)
  const loading = ref(false)

  const mensualites = computed(() => {
    if (!props.echeancier) {
      return []
    }
    return props.echeancier.mensualites.map(elem => { return { ...elem, date: dateUtil.formatEcheancier(elem.date) } })
  })

  const show = () => {
    popinRef.value.show()
  }
  const close = () => {
    popinRef.value.hide()
  }
  const updateEchancier = (code) => {
    loading.value = true;
    context.emit("updateEchancier", code)
  }

  watch(
    () => props.echeancier,
    (echeancier) => {
      if(echeancier && echeancier.code) {
        currentCode.value = echeancier.code;
        loading.value = false;
      }
    },
    { immediate: true }
  )

  return {
    currentCode,
    loading,
    mensualites,
    show,
    close,
    updateEchancier
  }
}